// source: api/soter-task/common/v1/video_category_enum.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.taskVideoCategory.TaskVideoCategory', null, global);
/**
 * @enum {number}
 */
proto.taskVideoCategory.TaskVideoCategory = {
  NONE: 0,
  INITIAL: 1,
  PROPOSED_CHANGE: 2,
  POST_CHANGE: 3
};

goog.object.extend(exports, proto.taskVideoCategory);
